/* eslint-disable max-params */
/* eslint-disable no-console */
/* eslint-disable no-bitwise */

function generateRandomId() {
  let u = '';
  let i = 0;
  while (i < 36) {
    const c = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'[i - 1]; const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    u += c === '-' || c === '4' ? c : v.toString(16);
    i += 1;
  }
  return u;
}

function getHeaders(loginData) {
  return {
    'Content-Type': 'application/json',
    App: 'TP',
    RequestId: generateRandomId(),
    applUserId: loginData?.applUserID,
    adsId: loginData?.adsId,
  };
}

export async function callApi(apiUrl, methodType, requestData, loginData) {
  let data = null;
  let isError = true;
  const url = apiUrl;
  let errMsg = 'Internal Server error';
  if (url) {
    try {
      const requestCommonData = {
        requestId: generateRandomId(),
        channelNm: 'POA UI',
        env: 'Cert',
        userEmail: loginData?.emailId,
        adsId: loginData?.adsId,
        appNm: 'TP',
        tpLoginUserId: loginData?.applUserID,
      };

      let response;
      if (methodType === 'POST' || methodType === 'PUT') {
        response = await fetch(url, {
          method: methodType,
          headers: getHeaders(loginData),
          credentials: 'include',
          body: JSON.stringify({ ...requestCommonData, ...requestData }),
        });
      } else if (methodType === 'GET' || methodType === 'DELETE') {
        response = await fetch(url, {
          method: methodType,
          headers: getHeaders(loginData),
          credentials: 'include',
        });
      }
      if (!response.ok) {
        const message = `An error has occured: ${response.status}`;
        if (response.status === 400 || response.status === 422 || response.status === 500) {
          const resData = await response.json();
          errMsg = resData.errorMsg;
          isError = true;
        } else {
          throw new Error(message);
        }
      } else {
        const userData = await response.json();
        console.log(userData);
        data = userData;
        isError = false;
      }
    } catch (exe) {
      console.error(exe);
      isError = true;
    }
  }
  return {
    data,
    isError,
    errMsg,
  };
}

export async function callApiWithEnhanceTable(
  apiUrl, methodType,
  requestData, loginData,
  updatedTableData,
  fetchAll = false,
  savePreferenceData = false) {
  let newRequestData = requestData;
  if (methodType === 'POST' || methodType === 'PUT') {
    const headerMap = Object.fromEntries(updatedTableData.headers.map((h) => [h.id, h]));
    const filterData = {};
    updatedTableData.headers
      .filter((h) => h.display === true)
      .forEach((h) => {
        filterData[`${h.id}ColF`] = headerMap[h.id].filter;
      });
    filterData.pageNum = updatedTableData.currentPage;
    filterData.pageSize = fetchAll ? 0 : updatedTableData.itemsPerPage;
    filterData.sortColumn = updatedTableData.sortBy;
    filterData.sortOrder = updatedTableData.sortDirection;
    console.log(` savePreferenceData ${savePreferenceData}`);
    if (savePreferenceData) {
      filterData.preferceData = updatedTableData.preferceData;
    }
    newRequestData = { ...filterData, ...requestData };
  }
  return callApi(apiUrl, methodType, newRequestData, loginData);
}
